import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 19h6a3 3 0 0 0 3 -3v-7","key":"svg-0"}],["path",{"d":"M10 13l4 -4l4 4m-8 -5l4 -4l4 4","key":"svg-1"}]]

const IconCornerRightUpDouble = createReactComponent('outline', 'corner-right-up-double', 'CornerRightUpDouble', __iconNode);

export default IconCornerRightUpDouble;